import { OrdersContainer } from '@/modules/Order';

const Orders = (): JSX.Element => <OrdersContainer />;

export default Orders;
